import { AxiosPromise } from 'axios';
import httpClient from 'api/httpClient';
import { Store, StoreDefaultRelease } from 'types/store';

export const getIndividualStore = (
  id: number | string,
): AxiosPromise<{ store: Store; defaultReleases: StoreDefaultRelease[] }> => {
  return httpClient({
    method: 'GET',
    url: `/super-admin/stores/${id}`,
  });
};
